





































import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import RewardCard from '@/components/SpinTheWheel/RewardCard.vue';
import { TierGift } from '~/features/cart/utils';
import { useCartAttributes } from '~/features/cart';
import { useGiftTiers } from '~/features/gift-tiers';
import { purify } from '~/directives/purify-html';

export default defineComponent({
  components: {
    RewardCard,
  },
  directives: {
    purify,
  },
  props: {
    gift: {
      type: Object as PropType<TierGift>,
      required: true,
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
  },
  setup({ gift }) {
    const { cartGifts, cartPromotions, subtotalWithDiscounts } = useCartAttributes();
    const giftNoLongerValid = computed(() => !cartGifts.value.some(cartGift => cartGift.sku === gift.sku));
    const validTierMinSubTotal = computed(() => {
      if (!giftNoLongerValid.value) {
        return 0;
      }

      return (
        cartPromotions.value?.options?.find(option =>
          (option?.gift as TierGift[])?.some(optionGift => optionGift.sku === gift.sku)
        )?.tier_minimum_subtotal ?? 0
      );
    });

    // Get amount of tier the gift is available in (instead of the next tier)
    const { amountRemaining } = useGiftTiers(
      validTierMinSubTotal,
      subtotalWithDiscounts,
      computed(() => ({
        tiers:
          cartPromotions.value?.options?.map(option => ({
            discountValue: option?.tier_minimum_subtotal || 0,
          })) || [],
        eligibleTierIdx: cartPromotions.value.eligiblePromotionIdx,
      }))
    );

    return {
      giftNoLongerValid,
      amountRemaining,
    };
  },
});
